import messageEnums from 'enums/messages';
import { analyticsEventTypes } from 'events/analytics';
import { MESSAGE_SENT_EVENT, SESSION_STARTED_EVENT } from 'GladlySidekickConstants';
import mapMessageType from './helpers/mapMessageType';

export default function messageSent() {
  return {
    [analyticsEventTypes.CHAT_MESSAGE_SENT]: ({ payload: { isInitialMessage, type } }) => {
      let events = [];

      switch (type) {
        case messageEnums.SUB_TYPES.IMAGE:
        case messageEnums.SUB_TYPES.FILE:
        case messageEnums.SUB_TYPES.TEXT:
          events.push({
            eventName: MESSAGE_SENT_EVENT,
            eventPayload: [
              {
                isInitialMessage,
                type: mapMessageType(type),
              },
            ],
          });

          if (isInitialMessage) {
            events.push({
              eventName: SESSION_STARTED_EVENT,
              eventPayload: [],
            });
          }
      }
      return events;
    },
  };
}
